import * as z from 'zod'

/**
 * Schema for taxonomy topics used to categorize and filter resources.
 * Topics come from the taxonomy service and are used for dynamic
 * resource discovery on index pages.
 */
export const TopicSchema = z.object({
  id: z.string(),
  preferred_label: z.string(),
  definition: z.string().optional(),
})

export type Topic = z.infer<typeof TopicSchema>
